var __WEBPACK_NAMESPACE_OBJECT__ = dependencies['@sitebase/ui-kit']['3.23.6']['module'];